import type { Campaign, CoinInfo, PlayerPrize } from '@/types/types'; // Adjust import path as needed
import type { DropAPI } from '@/types/DropAPI';

export function useDropAPI(options: { url: string; token: string }): DropAPI {
	const fetchDropList = async (): Promise<Campaign[]> => {
		const baseUrl = options.url + 'lobby/drop_campaigns';
		const response = await fetch(baseUrl, {
			headers: { Authorization: `Bearer ${options.token}` }
		});
		// if (!response.ok) {
		//   throw new Error('Failed to fetch drop list')
		// }
		const result = await response.json();
		return result.data as Campaign[];
	};

	const fetchPlayerWin = async (id: string | null): Promise<PlayerPrize | null> => {
		if (!id) {
			return null;
		}
		const baseUrl = options.url + `lobby/drop_campaigns/${id}/player_prize`;

		const response = await fetch(baseUrl, {
			headers: { Authorization: `Bearer ${options.token}` }
		});
		// if (!response.ok) {
		//   throw new Error('Failed to fetch player win')
		// }
		return response.json();
	};

	const fetchCoin = async (id: string | null): Promise<CoinInfo | null> => {
		if (!id) {
			return null;
		}
		const baseUrl = options.url + `lobby/drop_campaigns/${id}/coin_info`;
		const response = await fetch(baseUrl, {
			headers: { Authorization: `Bearer ${options.token}` }
		});
		//   if (!response.ok) {
		//   throw new Error('Failed to fetch coin data')
		// }
		return response.json();
	};

	const confirmPlayerWin = async (id: string | null): Promise<void> => {
		if (!id) {
			return;
		}
		///api/v1/lobby/won_prizes/{id}/acknowledge
		const baseUrl = options.url + `lobby/won_prizes/${id}/acknowledge`;
		const response = await fetch(baseUrl, {
			method: 'POST',
			headers: { Authorization: `Bearer ${options.token}` }
		});
		// if (!response.ok) {
		//   throw new Error('Failed to confirm player win')
		// }
		return response.json();
	};

	return {
		fetchDropList,
		fetchPlayerWin,
		fetchCoin,
		confirmPlayerWin
	};
}
